export default "__VITE_ASSET__56aff53a__"